import { SearchScenarioId } from 'owa-search-store';
import { getSuggestions, startSearch, searchSessionStarted } from 'owa-search-actions';
import { orchestrator } from 'satcheljs';
import { initializeAllLoadedAccounts } from 'owa-calendar-cache-loader';

/**
 * This is the spaces-specific startSearchSessionOrchestrator. It's responsible
 * for handling spaces-specific initialization.
 */
export default orchestrator(searchSessionStarted, async actionMessage => {
    const { actionSource, shouldStartSearch, scenarioId } = actionMessage;

    if (scenarioId != SearchScenarioId.Spaces) {
        return;
    }

    // TODO any package initialization that needs to be done before searching will work can be done here
    // if the accounts aren't already initialized by the time this lazy package loads, initialize them so we have
    // the existing calendar folder ids
    initializeAllLoadedAccounts();

    if (shouldStartSearch) {
        startSearch(actionSource, SearchScenarioId.Spaces);
    } else {
        getSuggestions(SearchScenarioId.Spaces);
    }
});
